import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { AuthenicationService } from '../../_services/authenication.service';
import { ContactusService } from '../../_services/contactus.service';
import {environment} from '../../../environments/environment';
import { ToasterService } from '../../_services/toaster.service';
import {ExcelServicesService} from "../../_services/excel-services.service";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";

declare var $: any;

@Component({
  selector: 'app-get-contacts',
  templateUrl: './get-contacts.component.html',
  styleUrls: ['./get-contacts.component.css']
})
export class GetContactsComponent implements OnInit {

  userdetaild: string;
  contactUsAllowedUsers: Array<string>;
  baseUrl: string = environment.baseUrl;
  returnUrl: string;
  contactlist: any;
  contactlist_data: any[] = [];

  constructor(private authenicationService: AuthenicationService, private router: Router, private route: ActivatedRoute, private contactusservice: ContactusService, private toaster: ToasterService, private excelService: ExcelServicesService,private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.contactUsAllowedUsers = ["abhishek@mindpeerssubadmin.com"];
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    if (!this.userdetaild || (this.userdetaild['users_usertype'] !== 'admin' && (this.contactUsAllowedUsers.indexOf(this.userdetaild['users_email'])===-1))) {
      this.authenicationService.logout();
      this.router.navigateByUrl('/login');
    }
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

    this.getAllContacts();
  }

  exportAsXLSX():void {
    this.spinnerService.show();
    this.excelService.exportAsExcelFile(this.contactlist_data, `customers_contact_list`);
    this.spinnerService.hide();
  }

  getAllContacts() {
    this.contactusservice.getAllContacts()
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            // this.toaster.showSuccess('Add Doctor', data.ResponseMessage);
            this.contactlist = data.quoteList;

            this.contactlist.forEach((row: any) => {
              const userdata = {
                Name: (row['name'])?row['name']:'',
                Email: (row['email'])?row['email']:'',
                Phone: (row['phone'])?row['phone']:'',
                Message: (row['message'])?row['message']:'',
                Date: (row['createdAt'])?row['createdAt']:'',
              };
              this.contactlist_data.push(userdata);
            });

            setTimeout(() => {
              $(function() {
                $('#example').DataTable();
              });
            }, 1000);
          } else {
            this.toaster.showError('Doctor', data.ResponseMessage);
            setTimeout( () => {
              $(function() {
                $('#example').DataTable();
              });
            }, 1000);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Doctor', error.error.ResponseMessage);
          setTimeout( () => {
            $(function() {
              $('#example').DataTable();
            });
          }, 1000);
        });
  }
}